'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _ApiClient = require('helpers/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _jschannel = require('jschannel');

var _jschannel2 = _interopRequireDefault(_jschannel);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  WeiboButton: {
    displayName: 'WeiboButton'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/ProviderButtons/WeiboButton.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
} /* global WB2 */


var WeiboButton = _wrapComponent('WeiboButton')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(WeiboButton, _Component);

  function WeiboButton(props) {
    (0, _classCallCheck3.default)(this, WeiboButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WeiboButton.__proto__ || (0, _getPrototypeOf2.default)(WeiboButton)).call(this, props));

    _this.componentDidMount = function () {
      _this.setState({
        state: Math.random().toString(36),
        nonce: Math.random().toString(36)
      });
    };

    _this.onClick = function (e) {
      e.preventDefault();
      _this.authorize().then(_this.props.callback).catch(_this.props.callback);
    };

    _this.authorize = function () {
      var popupWindow = _this.openPopup(_this.buildAuthorizeUrl());
      var channel = _jschannel2.default.build({
        window: popupWindow,
        origin: '*',
        scope: 'weibo'
      });
      _this.setState({ popupWindow: popupWindow, channel: channel });
      return new _promise2.default(function (resolve, reject) {
        channel.bind('authorized', function (context, params) {
          resolve(params);
          channel.destroy();
        });
        channel.bind('error', function (context, params) {
          reject(params);
          channel.destroy();
        });
      });
    };

    _this.buildAuthorizeUrl = function () {
      var config = _config2.default.weibo[_this.props.locale];
      var object = {
        client_id: config.clientId,
        redirect_uri: config.redirectUri,
        response_type: 'code'
      };
      var query = _querystring2.default.stringify(object);
      return config.oAuthUrl + '?' + query;
    };

    _this.openPopup = function (url) {
      var popupWidth = 400;
      var popupHeight = 585;
      var positionX = window.screen.width / 2 - popupWidth / 2;
      var positionY = window.screen.height / 2 - popupHeight / 2;
      return window.open(url, 'weibo', 'width="' + popupWidth + '",height="' + popupHeight + '",menubar=0,toolbar=0,directories=0,scrollbars=no,resizable=no,left="' + positionX + '",top="' + positionY + '"');
    };

    _this.client = new _ApiClient2.default();
    return _this;
  }

  (0, _createClass3.default)(WeiboButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          className = _props.className; // eslint-disable-line no-shadow

      return _react3.default.createElement(
        'button',
        { className: className ? className : 'weibo-button', style: className ? {} : style, onClick: this.onClick },
        this.props.buttonText
      );
      // return <div id="wb_connect_btn" ></div>;
    }
  }]);
  return WeiboButton;
}(_react2.Component), _class.propTypes = {
  style: _react2.PropTypes.object,
  className: _react2.PropTypes.string,
  callback: _react2.PropTypes.func.isRequired,
  buttonText: _react2.PropTypes.string,
  locale: _react2.PropTypes.string.isRequired
}, _class.defaultProps = {
  className: '',
  style: {
    backgroundColor: '#E90F24',
    border: '0',
    color: '#fff',
    fontWeight: '700',
    padding: '10px 70px'
  },
  buttonText: '微博登录'
}, _temp));

exports.default = WeiboButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProviderButtons/WeiboButton.js
// module id = 674
// module chunks = 47